var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form-wizard",
    {
      ref: "wizard",
      attrs: {
        color: _vm.color,
        title: _vm.title,
        subtitle: _vm.subtitle,
        shape: _vm.shape,
        "next-button-text": _vm.nextButtonText,
        "back-button-text": _vm.backButtonText,
        "finish-button-text": _vm.finishButtonText,
      },
      on: { "on-complete": _vm.handleComplete },
    },
    _vm._l(_vm.steps, function (step, index) {
      return _c(
        "tab-content",
        {
          key: index,
          attrs: { title: step.title, "before-change": step.beforeChange },
        },
        [
          step.component
            ? _c(
                step.component,
                _vm._g(
                  _vm._b(
                    { tag: "component" },
                    "component",
                    step.props || {},
                    false
                  ),
                  step.events || {}
                )
              )
            : _vm._e(),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }